/**
 * Отдельный vuex модуль для взаимодействия по analytics/garbage_access-API
 */

import {ANALYTICS, AnalyticSettings} from "@/store/analytics/helpers.js";
import makeMessage from "@/store/analytics/analyticMessage.js";

// actions для garbage_access. Вызов действия начинать с "analytics/garbageAccesss/"
export const ACTION_LOAD_GARBAGE_ACCESSS_SETTINGS = "LOAD_GARBAGE_ACCESSS_SETTINGS";
export const ACTION_LOAD_GARBAGE_ACCESS_SETTINGS = "LOAD_GARBAGE_ACCESS_SETTINGS";
export const ACTION_LOAD_GARBAGE_ACCESS_EVENTS = "LOAD_GARBAGE_ACCESS_EVENTS";
export const ACTION_LOAD_GARBAGE_ACCESS_EVENT = "LOAD_GARBAGE_ACCESS_EVENT";
export const ACTION_LOAD_GARBAGE_ACCESS_REPORT = "LOAD_GARBAGE_ACCESS_REPORT";

/**
 * Класс для представления настроек аналитики доступа к мусоркам.
 */
export class GarbageAccessSettings extends AnalyticSettings {
  get analyticType() {
    return ANALYTICS.garbage_access;
  }
}

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    /**
     * Загрузка списка настроек аналитик доступа к мусоркам.
     *
     * @param {Object} context
     * @param {Array.<String>} camerasNumbers
     * @return {Promise.<Array.<GarbageAccessSettings>>}
     */
    async [ACTION_LOAD_GARBAGE_ACCESSS_SETTINGS](context, {camerasNumbers}) {
      try {
        const response = await this.getters.ajaxClient.post("/v0/analytics/garbage_access/settings/", {camera_numbers: camerasNumbers});
        return response.data.results.map(rawGarbageAccessSettings => new GarbageAccessSettings(rawGarbageAccessSettings));
      } catch {
        return [];
      }
    },
    /**
     * Загрузка настроек аналитики доступа к мусоркам с конкретной камеры.
     *
     * @param {Function} dispatch
     * @param {String} cameraNumber
     * @return {Promise.<GarbageAccessSettings>}
     */
    async [ACTION_LOAD_GARBAGE_ACCESS_SETTINGS]({dispatch}, {cameraNumber}) {
      const garbageAccesssSettings = await dispatch(ACTION_LOAD_GARBAGE_ACCESSS_SETTINGS, {camerasNumbers: [cameraNumber]});
      if (_.isEmpty(garbageAccesssSettings)) {
        return null;
      }
      return garbageAccesssSettings[0];
    },
    /**
     * Загрузка перечня событий по аналитике доступа к мусоркам с камеры для формирования отчета.
     *
     * @param {Object} context
     * @param {String} cameraNumber
     * @param {Array.<Number>} eventIds
     * @return {Promise.<Array.<GarbageAccessMessage>>}
     */
    async [ACTION_LOAD_GARBAGE_ACCESS_EVENTS](context, {cameraNumber, eventIds}) {
      try {
        const response = await this.getters.ajaxClient.post("/v0/analytics/garbage_access/events/", {
          camera_number: cameraNumber,
          event_ids: eventIds,
        });
        return response.data.results.map(rawEventData => makeMessage(rawEventData, cameraNumber, ANALYTICS.garbage_access));
      } catch {
        return [];
      }
    },
    /**
     * Загрузка перечня событий по аналитике доступа к мусоркам с камеры для формирования отчета.
     *
     * @param {Function} dispatch
     * @param {String} cameraNumber
     * @param {Number} eventId
     * @return {Promise.<GarbageAccessMessage>}
     */
    async [ACTION_LOAD_GARBAGE_ACCESS_EVENT]({dispatch}, {cameraNumber, eventId}) {
      const garbageAccesssSettings = await dispatch(ACTION_LOAD_GARBAGE_ACCESS_EVENTS, {cameraNumber, eventIds: [eventId]});
      if (_.isEmpty(garbageAccesssSettings)) {
        return null;
      }
      return garbageAccesssSettings[0];
    },
    /**
     * Загрузка перечня событий по определению доступа к мусоркам с камеры для формирования отчета.
     *
     * @param {Object} context
     * @param {String} cameraNumber
     * @param {Date} archiveFrom
     * @param {Date} archiveTo
     * @param {String} query
     * @return {Promise.<Array.<GarbageAccessMessage>>}
     */
    async [ACTION_LOAD_GARBAGE_ACCESS_REPORT](context, {cameraNumber, archiveFrom, archiveTo, query = null, page, page_size}) {
      try {
        const response = await this.getters.ajaxClient.post("/v0/analytics/garbage_access/report/", {
          camera_number: cameraNumber,
          start: archiveFrom.toISOString(),
          end: archiveTo.toISOString(),
          query: query,
          page: page,
          page_size: page_size
        });
        const messages = response.data.results.map(rawEventData => makeMessage(rawEventData, cameraNumber, ANALYTICS.garbage_access));

        return {
          messages,
          response: response.data
        };
      } catch {
        return {
          messages: [],
          response: null
        };
      }
    },
  },
};
